import { render, staticRenderFns } from "./ButtonPlus.vue?vue&type=template&id=86435518&scoped=true"
import script from "./ButtonPlus.vue?vue&type=script&lang=js"
export * from "./ButtonPlus.vue?vue&type=script&lang=js"
import style0 from "./ButtonPlus.vue?vue&type=style&index=0&id=86435518&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86435518",
  null
  
)

export default component.exports